function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.01 10.22V14.71C21.01 19.2 19.22 21 14.72 21H9.33002C8.75002 21 8.21998 20.97 7.72998 20.9",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04004 14.52V10.22",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0299 11C13.8599 11 15.2099 9.51005 15.0299 7.68005L14.3599 1H9.68989L9.01991 7.68005C8.83991 9.51005 10.1999 11 12.0299 11Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3301 11C20.3501 11 21.8301 9.35998 21.6301 7.34998L21.35 4.59998C20.99 1.99998 19.9901 1 17.3701 1H14.3201L15.0201 8.01001C15.2001 9.66001 16.6801 11 18.3301 11Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67004 11C7.32004 11 8.81003 9.66001 8.97003 8.01001L9.19006 5.80005L9.67004 1H6.62005C4.00005 1 3.00007 1.99998 2.64007 4.59998L2.36004 7.34998C2.16004 9.35998 3.65004 11 5.67004 11Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 18.75 8.78998 19.4601 8.41998 20.0601C8.22998 20.3801 7.99998 20.67 7.72998 20.9C7.69998 20.94 7.67 20.97 7.63 21C6.93 21.63 6.01 22 5 22C3.78 22 2.68997 21.45 1.96997 20.59C1.94997 20.56 1.92002 20.54 1.90002 20.51C1.78002 20.37 1.67002 20.2201 1.58002 20.0601C1.21002 19.4601 1 18.75 1 18C1 16.74 1.58 15.61 2.5 14.88C2.67 14.74 2.84998 14.62 3.03998 14.52C3.61998 14.19 4.29 14 5 14C6 14 6.89998 14.36 7.59998 14.97C7.71998 15.06 7.82999 15.17 7.92999 15.28C8.58999 16 9 16.95 9 18Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48999 17.98H3.51001",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16.52V19.51",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.cc57b1d01d746e72097227b554cec2f6.svg";
export { ForwardRef as ReactComponent };